import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=7a0f2ea9&scoped=true"
var script = {}
import style0 from "./refund.vue?vue&type=style&index=0&id=7a0f2ea9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0f2ea9",
  null
  
)

export default component.exports